export function endDateValidation(this: any, endDate: number) {
  const { start: startDate } = this.parent;
  return startDate && endDate && new Date(endDate) >= new Date(startDate);
}

export function startDateValidation(this: any, startDate: number) {
  const { end: endDate } = this.parent;
  if (!endDate) return true;
  return startDate && endDate && new Date(endDate) >= new Date(startDate);
}

export function endDayValidation(this: any, endDay: number) {
  const { start: startDay } = this.parent;
  return startDay && endDay && endDay >= startDay;
}

export function startDayValidation(this: any, startDay: number) {
  const { end: endDay } = this.parent;
  if (!endDay) return true;
  return startDay && endDay && endDay >= startDay;
}

export function scrollToBottomById(elementId: string): void {
  setTimeout(() => {
    const element = document.getElementById(elementId);
    if (element) {
      const isOverflowing = element.scrollHeight > element.clientHeight;
      if (isOverflowing) {
        element.scrollTop = element.scrollHeight - element.clientHeight;
      }
    }
  }, 0);
}
